/* CAROUSEL SYSTEM (Services, Testimonials, News) */

export function initCarousels() {
  const configs = [
    { track: 'services-carousel', prev: 'svc-prev', next: 'svc-next', dots: 'svc-dots' },
    { track: 'testimonials-carousel', prev: 'test-prev', next: 'test-next', dots: 'test-dots' },
    { track: 'news-carousel',         prev: 'news-prev', next: 'news-next', dots: 'news-dots' },
    { track: 'about-carousel',        prev: 'about-prev', next: 'about-next', dots: 'about-dots' }
  ];

  configs.forEach(cfg => setupCarousel(cfg));
}

function setupCarousel(cfg) {
  const viewport = document.getElementById(cfg.track);
  const prevBtn = document.getElementById(cfg.prev);
  const nextBtn = document.getElementById(cfg.next);

  if (!viewport || !prevBtn || !nextBtn) return;

  const track = viewport.querySelector('.iaa-carousel-track, .carousel-track, .services-carousel-track, .testimonials-track, .news-carousel-track');
  const items = track ? Array.from(track.children) : Array.from(viewport.children);
  if (!items.length) return;

  const dotsContainer = cfg.dots ? document.getElementById(cfg.dots) : null;
  let dots = [];
  let snapPoints = [];

  function renderDots() {
    if (!dotsContainer) return;
    dotsContainer.innerHTML = '';
    dots = [];
    snapPoints = [];

    const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    if (maxScroll <= 0) return;

    const itemWidth = items[0].getBoundingClientRect().width;
    const gap = parseFloat(window.getComputedStyle(track || viewport).gap) || 0;
    const itemsPerPage = Math.max(1, Math.floor(viewport.clientWidth / (itemWidth + gap)));

    for (let i = 0; i < items.length; i += itemsPerPage) {
      const targetScroll = items[i].offsetLeft - (track ? track.offsetLeft : 0);
      if (targetScroll >= maxScroll) {
        snapPoints.push(maxScroll);
        break;
      }
      snapPoints.push(targetScroll);
    }

    if (snapPoints[snapPoints.length - 1] < maxScroll - 10) {
      snapPoints.push(maxScroll);
    }

    snapPoints.forEach((point, i) => {
      const dot = document.createElement('button');
      dot.className = 'carousel-dot';
      dot.setAttribute('aria-label', `Go to view ${i + 1}`);
      dot.addEventListener('click', () => {
        viewport.scrollTo({ left: point, behavior: 'smooth' });
      });
      dotsContainer.appendChild(dot);
      dots.push(dot);
    });
  }

  function getScrollAmount() {
    const itemWidth = items[0].getBoundingClientRect().width;
    const gap = parseFloat(window.getComputedStyle(track || viewport).gap) || 0;
    const itemsPerPage = Math.max(1, Math.floor(viewport.clientWidth / (itemWidth + gap)));
    return (itemWidth + gap) * itemsPerPage;
  }

  prevBtn.addEventListener('click', () => {
    viewport.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
  });

  nextBtn.addEventListener('click', () => {
    viewport.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
  });

  function updateState() {
    const max = viewport.scrollWidth - viewport.clientWidth;
    const atStart = viewport.scrollLeft <= 5;
    const atEnd = viewport.scrollLeft >= max - 5;

    prevBtn.style.opacity = atStart ? '0.3' : '1';
    nextBtn.style.opacity = atEnd ? '0.3' : '1';
    prevBtn.style.pointerEvents = atStart ? 'none' : '';
    nextBtn.style.pointerEvents = atEnd ? 'none' : '';

    if (dots.length > 0) {
      const currentScroll = viewport.scrollLeft;
      let activeIndex = 0;
      let minDiff = Infinity;

      snapPoints.forEach((point, i) => {
        const diff = Math.abs(currentScroll - point);
        if (diff < minDiff) {
          minDiff = diff;
          activeIndex = i;
        }
      });

      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === activeIndex);
      });
    }
  }

  viewport.addEventListener('scroll', updateState, { passive: true });
  window.addEventListener('resize', () => {
    renderDots();
    updateState();
  }, { passive: true });

  setTimeout(() => {
    renderDots();
    updateState();
  }, 150);

  viewport.setAttribute('tabindex', '0');
  viewport.setAttribute('role', 'region');
  viewport.setAttribute('aria-roledescription', 'carousel');
  viewport.setAttribute('aria-label', 'Content Carousel');

  prevBtn.setAttribute('aria-label', 'Previous slide');
  nextBtn.setAttribute('aria-label', 'Next slide');

  viewport.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft')  { e.preventDefault(); viewport.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' }); }
    if (e.key === 'ArrowRight') { e.preventDefault(); viewport.scrollBy({ left:  getScrollAmount(), behavior: 'smooth' }); }
  });

  // Drag to scroll
  let dragStartX = null;
  let dragging = false;
  let wasDragging = false;
  let startScroll;

  viewport.addEventListener('mousedown', (e) => {
    dragStartX = e.clientX;
    startScroll = viewport.scrollLeft;
    dragging = false;
    viewport.style.cursor = 'grabbing';
    viewport.style.userSelect = 'none';
  });

  window.addEventListener('mousemove', (e) => {
    if (dragStartX === null) return;
    const delta = dragStartX - e.clientX;
    if (Math.abs(delta) > 4) dragging = true;
    if (dragging) viewport.scrollLeft = startScroll + delta;
  });

  window.addEventListener('mouseup', () => {
    wasDragging = dragging;
    dragStartX = null;
    dragging = false;
    viewport.style.cursor = '';
    viewport.style.userSelect = '';
  });

  viewport.addEventListener('click', (e) => {
    if (wasDragging) { wasDragging = false; e.stopPropagation(); }
  }, true);
}


